import { Popover as CXPopOver } from '@sanlamcx/react-ui-next-popover';

export const Popover = CXPopOver;
